import { Component, OnInit } from '@angular/core';
import { ApiService } from '../services/api.service';
import { UtilitiesService } from '../services/utilities.service';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { CommonService } from '../services/common.service';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css'],
    standalone: false
})
export class HomeComponent implements OnInit {

  name: string = "";
  role: string = "";
  token: any;
  today: Date = new Date();

  doctors: any[] = [];
  slots: any[] = [];
  slots_filter: any[] = [];
  searchKey: any;

  dateList: Date[] = [];
  currentDay: Date = new Date();

  constructor(public utility: UtilitiesService, private api: ApiService, public datepipe: DatePipe, private router: Router, private common: CommonService) {
    this.utility.show = true;
    this.token = localStorage.getItem('access_token');
    this.name = localStorage.getItem('name')!;
    this.role = localStorage.getItem('role')!;


    if (!this.common.isUpdated()) { this.common.getDoctors(); };
    this.generateDateList();
  }

  ngOnInit(): void {
    this.getDoctors();
  }

  getWelcomeMessage(): string {
    const hour = this.today.getHours();

    if (hour < 12) return 'Good morning';
    if (hour < 18) return 'Good afternoon';
    return 'Good evening';
  }

  getDoctors() {
    let doctors = localStorage.getItem('doctors');

    if (doctors) {
      this.doctors = JSON.parse(doctors);
      //this.getDoctorsSlots();
    }
    // const sub = this.api.get('employees/role/doctor', this.token).subscribe(
    //   async data => {
    //     let objects: any = {}
    //     objects = data;

    //     this.doctors = objects;
    //   },
    //   async error => { }
    // );
    // sub.add(() => { this.getDoctorsSlots(); });
  }

  getDoctorsSlots() {
    this.utility.loading = true;
    const sub = this.api.get('appointments/doctor/all', this.token).subscribe(
      async data => {
        let objects: any = {}
        objects = data;

        if (objects.appointments != null)
          this.slots = objects.appointments;
        this.slots_filter = this.slots;
      },
      async error => { }
    );
    sub.add(() => { this.utility.loading = false; });
  }

  generateDateList() {
    this.dateList = [];
    for (let i = 0; i < 3; i++) {
      const date = new Date(this.currentDay.getFullYear(), this.currentDay.getMonth(), this.currentDay.getDate() + i);
      this.dateList.push(date);
    }
  }

  goToPrevious() {
    this.currentDay.setDate(this.currentDay.getDate() - 3);
    this.generateDateList();
  }

  goToNext() {
    this.currentDay.setDate(this.currentDay.getDate() + 3);
    this.generateDateList();
  }

  getThisDaySlots(date: any) {
    let select_date = this.datepipe.transform(date, 'yyyy-MM-dd');
    return this.slots.filter(i => this.datepipe.transform(i.schedule.date_time, 'yyyy-MM-dd') === select_date);
  }

  goToDetails(appointment: any) {
    localStorage.removeItem('appointment');
    localStorage.setItem('appointment', JSON.stringify(appointment));

    if (this.role === 'doctor')
      //this.router.navigate(['appointment_details']);
      this.router.navigate(['view_details']);
    else
      this.router.navigate(['view_details']);
  }

  searchSlots() {
    if (this.searchKey == null || this.searchKey === '') {
      this.slots = this.slots_filter;
    }
    else {
      this.slots = this.slots_filter;
      this.slots = this.slots.filter(i => i.patient.first_name.toLowerCase().indexOf(this.searchKey.toLowerCase()) >= 0 ||
        i.patient.last_name.toLowerCase().indexOf(this.searchKey.toLowerCase()) >= 0 ||
        i.patient.phone.toString() === this.searchKey.toLowerCase());
    }
  }

  getDoctorSlots(id: any) {
    this.doctors = this.doctors.filter(i => i.id === id);
    this.slots = this.slots.filter(i => i.appointment.doctor_id === id);
  }

  clear() {
    this.searchKey = '';
    this.getDoctors();
    this.slots = this.slots_filter;
  }
}
